<template>
	<div class="confirm-dialog">
    <Dialog width="580px" :canCloseWithEsc="true" :showCloseIcon="true">
			<template slot="title">
				<div class="title">
					{{ confirmState.title }}
				</div>
			</template>

			<template slot="body">
				<div class="description" v-html="confirmState.description"></div>
			</template>

			<template slot="actions">
        <div class="d-flex justify-end w-100" style="column-gap: 20px; padding: 12px 20px 28px">
          <Button
            :disabled="isLoading"
            dark
            color="#F16063"
            @click="confirm"
          >
            <span style="color: #ffffff" v-if="!isLoading"> Confirm </span>
            <span style="color: #ffffff" v-if="isLoading"> Loading... </span>
          </Button>

          <Button
						dark
						outlined
						color="grey"
						@click="close"
					>
						<span style="color: #1A202C">Cancel</span>
					</Button>

				</div>
			</template>
		</Dialog>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Dialog from '@/components/layouts/dialog';
import Button from '@/components/elements/Button';
import Image from '@/mixins/Image';
import { trackEvent } from '@/utils/analytics'

export default {
	name: 'confirm-dialog',
	props: {
		query: {
			type: Object
		}
	},
	data: () => ({
		isLoading: false
	}),
	components: { Dialog, Button },
	mixins: [Image],
	methods: {
		...mapMutations('dialogs', ['TOGGLE_DIALOG']),
		async confirm() {
			const {
				id,
				action,
				afterAction,
				whose,
				surveyId,
				resultId,
				questionNumber,
				visitId,
				data,
				callback
			} = this.confirmState;
			if (whose === 'quickEntry') {
				await this.$store.dispatch(action, { surveyId, questionNumber });
				await this.$store.dispatch(afterAction.name, { surveyID: surveyId });

				this.close()

			} else if (whose === 'survey') {
        trackEvent(this, 'delete_all_survey_entries', 'Survey', 'All Entries Were Deleted', {
          surveyId: surveyId
        })
        const res = await this.$store.dispatch(action, { surveyId, questionNumber });
        if (res) {
          this.$emit('afterAction')
        }
        this.close()

      } else if (whose === 'confirmationDeleteVisit') {
        trackEvent(this, 'delete_evaluation', 'Evaluation', 'Evaluation Was Deleted', {
          visitId: visitId
        })
				await this.$store.dispatch(action, visitId);
				this.close();
				this.TOGGLE_DIALOG({ name: 'modalConfirmationDeleteVisit', isOpen: false, root: true });

				this.$router.push(afterAction.name);

			} else if (whose === 'patientInviteToPortal') {
				this.TOGGLE_DIALOG({
					id: data.id,
					name: 'editPatient',
					isOpen: true,
					title: 'Edit patient',
					root: true
				});
				this.close()

			} else if (whose === 'confirmationMoveEvaluation') {
        await this.$store.dispatch(action, visitId)
        this.close()
      } else if (whose === 'confirmationDeleteReceipt') {
				const res = await this.$store.dispatch(action, {
					form: { resultId, receiptId: id }
				});
				await this.$store.dispatch('visits/updateTotalInvoices', {
					totalInvoices: res.totalInvoicesCount
				});
				this.$emit('showPopup', res);
				this.close()
			} else {
				if (!callback) {
					const res = await this.$store.dispatch(action, id);
          if (action === 'patients/activatePatient') {
            trackEvent(this, 'activate_patient', 'Patient', 'Patient was Activated', {
              patient_id: id
            });
          } else if (action === 'patients/deactivatePatient') {
            trackEvent(this, 'deactivate_patient', 'Patient', 'Patient was Deactivated', {
              patient_id: id
            });
          }
					this.$emit('showPopup', { type: this.confirmState.type, data: res });

					if (this._.isObject(afterAction)) {
						if (this.query) {
							await this.$store.dispatch(afterAction.name, this.query);
						} else if (afterAction.protocol) {
							await this.$store.dispatch(
								afterAction.name,
								afterAction.protocol
							);
						} else if (afterAction.orderMethod) {
							await this.$store.dispatch(afterAction.name, {
								id: afterAction.id,
								orderMethod: afterAction.orderMethod
							});
						} else {
							await this.$store.dispatch(afterAction.name, afterAction.id);
						}
					}
				}

				if (callback) {

					if(action) {
						const res = await this.$store.dispatch(action, id);
						this.$emit('showPopup', { type: this.confirmState.type, data: res });
					}

					console.log({ callback });
					this.isLoading = true;

					await callback();

					this.isLoading = false;
				}

				this.$emit('close');
				this.close()
			}
		},
		close() {
			this.TOGGLE_DIALOG({ name: 'confirm', isOpen: false });
		}
	},
	computed: {
		...mapState({
			confirmState: (state) => state.dialogs.confirm
		})
	}
};
</script>

<style lang="scss" scoped>
.w-100 {
	width: 100%;
}
.confirm-dialog {

	::v-deep .v-dialog__container {
    .v-card__actions {
      .button {

       .v-btn {
          border-radius: 16px;
          height: 56px !important;
          font-size: 14px;
          letter-spacing: 0;
          padding: 0 24px;
        }
      }
    }

		.v-card {
			&__title {
        padding: 36px 36px 33px !important;
        position: relative;

				.image {
          text-align: center;
          cursor: pointer;
				}
				.title {
          font-family: 'Poppins';
          font-weight: 600;
          font-size: 28px !important;
          color: #27272E;
          letter-spacing: 0 !important;
				}
				.v-icon {
					display: none;
					position: absolute;
					right: 15px;
					top: 25px;
				}
			}
			&__text {
				.description {
          font-family: 'Poppins';
          padding: 0 36px 63px 36px;
          font-weight: 400;
          font-size: 18px;
          line-height: 1.66;
          color: #1A202C;
          letter-spacing: 0;
				}
				.v-input {
					.v-text-field__details {
						display: none;
					}
				}
			}
		}
	}
}
</style>
